import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { formElementTypes } from "../../../../../utils/Constant";
import MultiInputFields from "../html-form/multi-input-fields";

export default function MultiInputPreview({
  element,
  inputValueChange,
  disabled,
  isQC,
  showRequiredField,
}: any) {
  const [rows, setRows] = useState<any>([]);
  const [numberOfColumns, setNumberOfColumns] = useState(0);

  useEffect(() => {
    if (element && element?.type === formElementTypes.multiInput) {
      multiInputChildElements();
    }
  }, [element]); // eslint-disable-line

  const multiInputChildElements = () => {
    const filterColumn1 = element?.childElements.filter(
      (element: any) => element?.multiInputElementSettings?.column === 1
    );
    const filterColumn2 = element?.childElements.filter(
      (element: any) => element?.multiInputElementSettings?.column === 2
    );
    const filterColumn3 = element?.childElements.filter(
      (element: any) => element?.multiInputElementSettings?.column === 3
    );

    let numOfRows = filterColumn1.length;
    if (numOfRows < filterColumn2.length) {
      numOfRows = filterColumn2.length;
    }
    if (numOfRows < filterColumn3.length) {
      numOfRows = filterColumn3.length;
    }

    const allRows: any[] = [];
    let columnsLength = 0;
    for (let i = 1; i <= numOfRows; i++) {
      const row = element?.childElements.filter(
        (element: any) => element?.multiInputElementSettings?.row === i
      );
      if (columnsLength < row.length) {
        columnsLength = row.length;
      }
      allRows.push(row);
    }
    setRows(allRows);
    setNumberOfColumns(columnsLength);
  };

  const updatedValue = (value: string, childElementId: string) => {
    if (inputValueChange) {
      inputValueChange({ id: childElementId, answer: value });
    }
  };

  return (
    <Box>
      {rows.map((columns: any[]) => {
        const column1 = columns.find(
          (column) => column?.multiInputElementSettings?.column === 1
        );
        const column2 = columns.find(
          (column) => column?.multiInputElementSettings?.column === 2
        );
        const column3 = columns.find(
          (column) => column?.multiInputElementSettings?.column === 3
        );
        return (
          <Box sx={{ display: "flex", width: "100%" }}>
            {column1 ? (
              <Box
                sx={{
                  mt: 2,
                  width: column2?.length > 0 ? "calc(100% - 8px)" : "100%",
                }}
              >
                <MultiInputFields
                  cell={column1}
                  updatedValue={updatedValue}
                  disabled={disabled}
                  isQC={isQC}
                  showRequiredField={showRequiredField}
                />
              </Box>
            ) : (
              <Box
                sx={{
                  width: column2?.length > 0 ? "calc(100% - 8px)" : "100%",
                }}
              ></Box>
            )}

            {numberOfColumns > 1 && [
              column2 ? (
                <Box
                  sx={{
                    mt: 2,
                    ml: 1,
                    width:
                      column3?.length > 0
                        ? "calc(100% - 16px)"
                        : "calc(100% - 8px)",
                  }}
                >
                  <MultiInputFields
                    cell={column2}
                    updatedValue={updatedValue}
                    disabled={disabled}
                    isQC={isQC}
                    showRequiredField={showRequiredField}
                  />
                </Box>
              ) : (
                <Box
                  sx={{
                    width:
                      column3?.length > 0
                        ? "calc(100% - 16px)"
                        : "calc(100% - 8px)",
                  }}
                ></Box>
              ),
            ]}
            {numberOfColumns > 1 && [
              column3 ? (
                <Box
                  sx={{
                    mt: 2,
                    ml: 1,
                    width: "calc(100% - 8px)",
                  }}
                >
                  <MultiInputFields
                    cell={column3}
                    updatedValue={updatedValue}
                    disabled={disabled}
                    isQC={isQC}
                    showRequiredField={showRequiredField}
                  />
                </Box>
              ) : (
                <Box sx={{ width: "calc(100% - 8px)" }}></Box>
              ),
            ]}
          </Box>
        );
      })}
    </Box>
  );
}
